import React, { useMemo } from "react";

import { Modal, ModalBody } from "reactstrap";

import { IAuditData, IGeneratedPrimeTableColumn, IPrimeTableColumn, ISelectChoicesObj } from "components/prime-data-table/interfaces";
import { auditForeignKeysColumns } from "./expertise-audit";
import { useFetchTableData } from "hooks/useFetchTableData";
import { auditColumns, idColumn } from "./audit-columns";
import { useDeepCompare } from "hooks/useDeepCompare";
import { GT } from "components/index";
import { useTranslation } from "react-i18next";

interface IDeletedRecordsTableProps {
    auditData: IAuditData | undefined;
    tableName: string;
    tableColumns: IGeneratedPrimeTableColumn[];
    modalOpen: boolean;
    selectChoices: ISelectChoicesObj | null | undefined;
    url?: string;
    params?: Record<string, unknown>;
    closeModal: () => void;
}

export const AuditDeletedRecordsTable = (props: IDeletedRecordsTableProps) => {
    const { modalOpen } = props;

    return (
        <GT.StatelessModalWrapper modalOpen={modalOpen}>
            <DeletedRecordsTable {...props} />
        </GT.StatelessModalWrapper>
    );
};

const DeletedRecordsTable = (props: IDeletedRecordsTableProps) => {
    const {
        closeModal,
        auditData,
        tableName,
        tableColumns,
        modalOpen,
        selectChoices,
        url = "deleted-instances-audit",
        params = {
            appLabel: auditData?.appLabel,
            model: auditData?.model,
        },
    } = props;

    const { data, handleReload } = useFetchTableData({
        url,
        configParams: { params },
    });

    const { t } = useTranslation();

    const historyTypeChoices = [
        { label: t("auditApp>>Change"), value: "~" },
        {
            label: t("auditApp>>Add"),
            value: "%2B",
        },
        {
            label: t("auditApp>>Delete"),
            value: "-",
        },
    ];

    const deepComparedData = useDeepCompare(data);

    const columns: IPrimeTableColumn[] = useMemo(() => {
        let foreignKeysColumns: IPrimeTableColumn[] = [];
        if (!!(data as any)?.foreignKeys) {
            foreignKeysColumns = auditForeignKeysColumns({
                columns: [...tableColumns],
                foreignKeys: (data as any)?.foreignKeys,
            });
        }

        let allColumns: IPrimeTableColumn[] = [...tableColumns.map((col) => ({ ...col, width: 123 })), ...foreignKeysColumns];

        return allColumns;
    }, [deepComparedData]);

    const columnsWithIdColumn = [...auditColumns.slice(0, 1), idColumn, ...auditColumns.slice(1)];

    return (
        <Modal className="audit-window" isOpen={modalOpen} toggle={closeModal} fade>
            <GT.ModalHeader closeModal={closeModal} name="Audit - deleted records" />
            <ModalBody style={{ overflowY: "auto" }}>
                <GT.PrimeDataTable
                    tableName={`audit-table-deleted-${tableName}`}
                    notSelectFirst
                    onReload={handleReload}
                    dataSet={data?.data}
                    meta={data?.meta}
                    columns={[...columnsWithIdColumn, ...columns]}
                    idSelector="historyId"
                    adjustTableHeight={300}
                    getContainerHeight={false}
                    selectChoices={{ historyType: historyTypeChoices, ...selectChoices }}
                ></GT.PrimeDataTable>
            </ModalBody>
            <GT.ModalFooter closeModal={closeModal} cancelName="Close" />
        </Modal>
    );
};
